import { BadRequestError } from '@cian/valuation-utils-component';

import { TThunkAction } from '../../types/redux';
import {
  fetchValidatePhone,
  IValidatePhoneRequest,
  IValidatePhoneResponse,
  IValidatePhoneResponse200,
  IValidatePhoneResponse400,
} from '../../repositories/demand/v1/validate-phone';

export const requestValidatePhone = (
  parameters: IValidatePhoneRequest,
): TThunkAction<Promise<IValidatePhoneResponse | BadRequestError | Error>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const res = await fetchValidatePhone<IValidatePhoneResponse200, IValidatePhoneResponse400>({
        httpApi,
        parameters,
      });

      if (res.statusCode === 200) {
        return {
          confirmTimeout: res.response.confirmTimeout,
          status: res.response.status,
        };
      }

      throw new BadRequestError({
        domain: 'requestValidatePhone.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      if (error instanceof BadRequestError) {
        logger.debug('requestValidatePhone: bad request', { message: error.message, domain: error.domain });
      } else {
        logger.error(error, { message: 'requestValidatePhone: server error' });
      }

      return error as Error;
    }
  };
};
